export default __webpack_public_path__ + "static/media/DUBAI.e2de8e30.jpg";